export const enum EServiceType {
    main = 'main',
    included = 'included',
    additional = 'additional',
}

export const enum EStages {
    init = 'init',
    activate = 'activate',
    datePicker = 'datePicker',
    costInfo = 'costInfo',
    result = 'result',
}

export interface IBaseService {
    id: number,
    type: EServiceType,
    title: string,
    productId: number,
    isChecked: boolean,
    description: string,
    innerServices: string[],
    suspendCost: number,
    isSuspended: boolean,
    suspendedDateFrom: string,
    suspendedDateTo: string,
    sortIdx: number,
}
export interface IState {
    isLoading: boolean,
    errorMessage: string,
    successResult: boolean,

    currentStage: EStages,
    showSuspended: boolean,

    services: Record<number, IBaseService>,

    suspendFrom: string,
    suspendTo: string,

    suspendPrice: number,
    recommendPay: number,
    remainingPay: number,
    balanceAfterSuspend: number,
    daysToUnsuspendTv: number,
}
